var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('footer',{staticClass:"footer"},[_c('p',[_c('span',{staticClass:"strong"},[_vm._v("Daniel Bedggood")])]),_c('p',[_vm._v("Copyright 2019")])])}]

export { render, staticRenderFns }